import { addDoc, collection } from "firebase/firestore";
import { db } from "@/lib/firebase";

export type AuditActorType = "owner" | "staff";

export type AuditAction =
  | "sale"
  | "expense"
  | "product_edit"
  | "product_delete"
  | "product_add"
  | "transaction_delete"
  | "settings_change"
  | "staff_login"
  | "staff_logout"
  | "price_change";

export interface AuditEvent {
  at: string;
  actorType: AuditActorType;
  actorLabel: string;
  deviceId: string;
  action: AuditAction;
  targetId: string | null;
  meta: Record<string, any> | null;
}

function resolveActor(): { actorType: AuditActorType; actorLabel: string; deviceId: string } {
  // Mobile is owner-only for Ultimate. Pro/Basic mobile users may also write audit
  // entries for their own actions (staff never sign into mobile in this build).
  const deviceId =
    (typeof window !== "undefined" && localStorage.getItem("dh_mobile_device_id")) || "mobile";
  return { actorType: "owner", actorLabel: "Owner", deviceId };
}

export async function logAction(params: {
  ownerUid: string;
  action: AuditAction;
  targetId?: string;
  meta?: Record<string, any>;
}): Promise<void> {
  try {
    const { ownerUid, action, targetId = null, meta = null } = params;
    if (!ownerUid) return;
    const { actorType, actorLabel, deviceId } = resolveActor();
    const event: AuditEvent = {
      at: new Date().toISOString(),
      actorType,
      actorLabel,
      deviceId,
      action,
      targetId,
      meta,
    };
    await addDoc(collection(db, "users", ownerUid, "auditLog"), event);
  } catch (err) {
    console.warn("[audit] logAction failed:", err);
  }
}
